// extracted by mini-css-extract-plugin
export default {"center-page":"CenterPage_center-page__xvNyw"};